"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
const styleOverrides = {
  root: ({
    theme
  }) => ({
    color: theme.palette.default.dark,
    '&:hover': {
      backgroundColor: theme.palette.grey[100]
    },
    [`&.${_material.checkboxClasses.checked}`]: {
      color: theme.palette.default.dark
    },
    [`&.${_material.checkboxClasses.checked}.${_material.checkboxClasses.disabled}`]: {
      color: theme.palette.grey[400]
    }
  })
};
const defaultProps = {
  icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckboxEmpty, {}),
  indeterminateIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckboxIndeterminate, {}),
  checkedIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckboxChecked, {}),
  color: 'inputElements'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
